import React, { useEffect, useRef, useState } from 'react';
import styles from '../../css/download.module.css'
import { postAsync } from '../../utils/httpClient';

const Downloads = () => {

  const renderRef = useRef(true);
  const [link, setLink] = useState();

  useEffect(() => {
    if (renderRef.current) {
      renderRef.current = false; // 첫 렌더링 이후에는 두번 호출되지 않도록 설정
      postAsync('/v2/thirdparty/deliverycatch/download', {})
        .then((res) => {
          setLink(res.data)
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

  }, []);

  const handlePWAInstall = async (e) => {
    e.preventDefault(); // a 링크 기본 동작 막음

    // window 내장 객체에 저장한값 가져오기 (*route.js 에서 설정 참고)
    const promptEvent = window._deferredPrompt;
    // 저장값이 없을시 return
    if (!promptEvent) {
      return;
    }

    // 가져온 객체를 prompt 창으로 호출
    promptEvent.prompt();

    const result = await promptEvent.userChoice;
    if (result.outcome === "accepted") {
      console.log("설치 완료");
    } else {
      console.log("설치 취소");
    }

    window._deferredPrompt = null; // 한 번 쓰고 제거
  };

  // 모바일에선 안나오게 설정 (모바일인지 확인하는 정규식)
  const isMobile = /Mobi|iPhone|Android/i.test(navigator.userAgent);


  return (
    <div>
      <div id={styles.sub_con_warp}>
        <div className={styles.sub21_con01}>
          <ul>
            <li>
              <div className={styles.sub21_con01_title01}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>관제 프로그램</p>
                <p className={styles.sub21_text02}>사용자 편의에 따라 커스텀 설정 가능</p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (android)
                  </div>
                  <a className={styles.sub21_con01_2_right} href={link?.adminWeb?.aos}
                    aria-label="관제 APK 다운로드"
                    type="application/vnd.android.package-archive"
                    download
                    >
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div> 
                  <div className={styles.sub21_con01_3}>
                    <div className={styles.sub21_con01_2_left}>
                      WEB 다운로드
                    </div>
                    <a className={styles.sub21_con01_2_right} href="#!" onClick={handlePWAInstall} alt="CATCH 관제" target="_blank" rel='noreferrer'>
                      <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                    </a>
                  </div> 
                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    WEB
                  </div>
                  <a className={styles.sub21_con01_2_right} href={link?.adminWeb?.web} alt="CATCH 관제" target="_blank" rel='noreferrer'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title02}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>상점용 프로그램</p>
                <p className={styles.sub21_text02}>남녀노소 쉽게 사용 가능한 간편한 조작</p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    PC, POS (Windows)/Exe
                  </div>
                  <a className={styles.sub21_con01_2_right} href={link?.store?.exe}>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    PC, POS (Windows)/Zip
                  </div>
                  <a className={styles.sub21_con01_2_right} href={link?.store?.zip}>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title03}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>기사용 프로그램</p>
                <p className={styles.sub21_text02}>실시간 오더 위치 확인</p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (android)
                  </div>
                  <a className={styles.sub21_con01_2_right} href={link?.rider?.aos}>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (ios)
                  </div>
                  <div className={styles.sub21_con01_2_right} onClick={() => alert('준비중입니다.')}>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' style={{ cursor: 'pointer' }} />
                  </div>
                </div>
                {/* 
                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>APK 다운로드 (v1.29.6+74)</div>
                  <a
                    className={styles.sub21_con01_2_right}
                    href="https://catch-admin.s3.ap-northeast-2.amazonaws.com/download/rider/catch_rider_v1.29.6%2B74.apk"
                    aria-label="APK 다운로드 (v1.29.6+74)"
                    type="application/vnd.android.package-archive"
                    download
                  >
                    <img src="../img10/sub21_ico01.png" alt="Download icon" />
                  </a>
                </div> 
                */}
              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title04}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>원격 제어</p>
                <p className={styles.sub21_text02}>사용자 편의를위해 원격 제어를 제공합니다. </p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    원격제어 프로그램
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://anydesk.com/ko/downloads/thank-you?dv=win_exe' target='_blank' rel='noreferrer'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>
              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title04}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>기타 프로그램</p>
                <p className={styles.sub21_text02}>기타 다양한 프로그램</p>
                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    .NET 프레임워크 4.6.2
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://dotnet.microsoft.com/ko-kr/download/dotnet-framework/thank-you/net462-web-installer' target='_blank' rel="noreferrer">
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    HHD 시리얼포트 모니터링 3.0.1
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://devdownload.deliverycatch.com/dist/hhdspmc.exe'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    윈도우7 IE11 32비트
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://devdownload.deliverycatch.com/dist/etc/EIE11_KO-KR_MCM_WIN7.EXE'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    윈도우7 IE11 64비트
                  </div>
                  <a className={styles.sub21_con01_2_right} href='https://devdownload.deliverycatch.com/dist/etc/EIE11_KO-KR_MCM_WIN764.EXE'>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    서브용 가맹점프로그램
                  </div>
                  <a className={styles.sub21_con01_2_right} href={link?.store?.sub}>
                    <img src="../img10//sub21_ico01.png" alt='DownloadIcon' />
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Downloads;
